/**
 * F60 — sub-navigation between /ops/logs and /ops/health (a Chip tab row,
 * like AnalyticsNav).
 */
import { useI18n } from '@bravemove/i18n/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Chip } from '@bravemove/ui-web';

const TABS: ReadonlyArray<{ route: string; labelKey: string; testId: string }> = [
  { route: '/ops/logs', labelKey: 'admin:opsLogs.nav.logs', testId: 'ops-nav-logs' },
  { route: '/ops/health', labelKey: 'admin:opsLogs.nav.health', testId: 'ops-nav-health' },
];

export function OpsNav() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-wrap items-center gap-2" aria-label={t('admin:opsLogs.title')}>
      {TABS.map((tab) => (
        <Chip
          key={tab.route}
          selected={pathname === tab.route}
          onClick={() => navigate(tab.route)}
          data-testid={tab.testId}
        >
          {t(tab.labelKey)}
        </Chip>
      ))}
    </nav>
  );
}
